import CryptoCurrency from '~/shared/legacy_models/Currency/CryptoCurrency';
import Currency from '~/shared/legacy_models/Currency/Currency';
import FiatCurrency from '~/shared/legacy_models/Currency/FiatCurrency';
import USDCCurrency from '~/shared/legacy_models/Currency/USDCCurrency';

type CurrencyCode = 'EUR' | 'USD' | 'ETH' | 'BTC' | 'USDC';

export default function getCurrencyClass(currencyName: string, type: 'Crypto' | 'Token' | 'Fiat' | null = null) {
    const currencies: Record<CurrencyCode, typeof Currency> = {
        EUR: FiatCurrency,
        USD: FiatCurrency,
        ETH: CryptoCurrency,
        BTC: CryptoCurrency,
        USDC: USDCCurrency,
    };

    const currencyTypes = {
        Crypto: CryptoCurrency,
        Token: Currency,
        Fiat: FiatCurrency,
    };

    const byCurrencyName = currencies[currencyName.toUpperCase() as CurrencyCode];
    const byCurrencyType = type !== null ? currencyTypes[type] : null;

    return byCurrencyName ?? byCurrencyType ?? Currency;
}
